/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateGoodsFeeVo
 */
export interface UpdateGoodsFeeVo {
    /**
     * 商品ID
     * @type {number}
     * @memberof UpdateGoodsFeeVo
     */
    id?: number;
    /**
     * 国内运输费用
     * @type {number}
     * @memberof UpdateGoodsFeeVo
     */
    chinaDomesticShippingFee?: number;
    /**
     * 采购税
     * @type {number}
     * @memberof UpdateGoodsFeeVo
     */
    purchaseTax?: number;
    /**
     * 附加费
     * @type {number}
     * @memberof UpdateGoodsFeeVo
     */
    additionalFee?: number;
    /**
     * 开发票公司名称
     * @type {string}
     * @memberof UpdateGoodsFeeVo
     */
    invoiceCompany?: string;
    /**
     * 备注留言
     * @type {string}
     * @memberof UpdateGoodsFeeVo
     */
    remark?: string;
}

/**
 * Check if a given object implements the UpdateGoodsFeeVo interface.
 */
export function instanceOfUpdateGoodsFeeVo(value: object): value is UpdateGoodsFeeVo {
    return true;
}

export function UpdateGoodsFeeVoFromJSON(json: any): UpdateGoodsFeeVo {
    return UpdateGoodsFeeVoFromJSONTyped(json, false);
}

export function UpdateGoodsFeeVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateGoodsFeeVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'chinaDomesticShippingFee': json['chinaDomesticShippingFee'] == null ? undefined : json['chinaDomesticShippingFee'],
        'purchaseTax': json['purchaseTax'] == null ? undefined : json['purchaseTax'],
        'additionalFee': json['additionalFee'] == null ? undefined : json['additionalFee'],
        'invoiceCompany': json['invoiceCompany'] == null ? undefined : json['invoiceCompany'],
        'remark': json['remark'] == null ? undefined : json['remark'],
    };
}

export function UpdateGoodsFeeVoToJSON(json: any): UpdateGoodsFeeVo {
    return UpdateGoodsFeeVoToJSONTyped(json, false);
}

export function UpdateGoodsFeeVoToJSONTyped(value?: UpdateGoodsFeeVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'chinaDomesticShippingFee': value['chinaDomesticShippingFee'],
        'purchaseTax': value['purchaseTax'],
        'additionalFee': value['additionalFee'],
        'invoiceCompany': value['invoiceCompany'],
        'remark': value['remark'],
    };
}

